/**
 * 获取app版本号
 * 版本号第一位不能为0，一共3位，每一位不超过两位数
 */
export const version = (userAgent: string): string => {
  const str = userAgent;
  const version = str.split('SuperApp ')[1]?.match(/^[1-9]\d?(\.([0-9]\d?)){2}/g);
  if (version) {
    return version[0];
  }
  return 'error';
};
